import * as jwtDecode from "jwt-decode";

const has2FA = (user) => user.jwt && jwtDecode(user.jwt).confirmed;

export {
  has2FA,
}
